/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AgeassuranceDefs from './defs.defs.js'

const $nsid = 'app.bsky.ageassurance.getConfig'

export { $nsid }

/** Returns Age Assurance configuration for use on the client. */
const main = l.query(
  $nsid,
  l.params(),
  l.payload(
    'application/json',
    l.ref<AgeassuranceDefs.Config>((() => AgeassuranceDefs.config) as any),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
